import React from "react";

import CustomizationContext, { CustomizationContextState } from "./CustomizationContext";

// Wraps around App to be able to pull global state anywhere in tree via useContext
const useCustomizationContext = (): CustomizationContextState =>
  React.useContext(CustomizationContext);

export default useCustomizationContext;
